import { useState } from "react";
import Modal from "./Modal";

const nav = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

const quickLinks = [
  { label: "Home", href: "#home" },
  { label: "Products", href: "#products" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export function TermsContent() {
  return (
    <div className="space-y-5">
      <p className="text-gray-400 text-xs">Last updated: April 2026</p>
      {[
        ["1. Product Availability", "All products are subject to availability. We reserve the right to limit quantities or discontinue products without prior notice."],
        ["2. Pricing", "Prices are indicative and may change without prior notice. The final confirmed price will be communicated at order confirmation."],
        ["3. Warranty & Guarantee", "No warranty is provided unless explicitly stated. SuperFast Auto Spares is not liable for damage from improper installation or product misuse."],
        ["4. User Responsibilities", "You agree to provide accurate contact details when submitting enquiries. False or misleading information may result in your enquiry being disregarded."],
        ["5. Limitation of Liability", "Our liability shall not exceed the purchase price paid. We are not responsible for indirect or consequential damages."],
        ["6. Governing Law", "These terms are governed by the laws of the State of Utah, USA. Any disputes shall be subject to the jurisdiction of courts in Washington County, UT."],
      ].map(([title, text]) => (
        <div key={title}>
          <h3 className="text-gray-900 font-semibold mb-1">{title}</h3>
          <p className="text-gray-500 text-sm leading-relaxed">{text}</p>
        </div>
      ))}
    </div>
  );
}

export function PrivacyContent() {
  return (
    <div className="space-y-5">
      <p className="text-gray-400 text-xs">Last updated: April 2026</p>
      {[
        ["1. Data We Collect", "We collect only your name and phone number when you submit an enquiry. We do not collect unnecessary personal data."],
        ["2. How We Use It", "Your contact information is used solely to respond to your enquiry via SMS. No unsolicited marketing without explicit consent."],
        ["3. Data Sharing", "We do NOT sell, trade, or share your personal information with third parties for any purpose."],
        ["4. Consent", "By submitting our form and ticking the consent checkbox, you explicitly agree to be contacted via SMS for enquiry-related communication."],
        ["5. Retention", "Enquiry data is retained for a maximum of 90 days after resolution, then securely deleted."],
        ["6. Your Rights", "You may request deletion of your data at any time by emailing info@superfastautospares.com. We process requests within 7 business days."],
      ].map(([title, text]) => (
        <div key={title}>
          <h3 className="text-gray-900 font-semibold mb-1">{title}</h3>
          <p className="text-gray-500 text-sm leading-relaxed">{text}</p>
        </div>
      ))}
    </div>
  );
}

export default function Footer() {
  const [modal, setModal] = useState(null);

  return (
    <>
      <footer className="bg-gray-900 text-white" role="contentinfo">
        {/* Top CTA band */}
        <div className="relative overflow-hidden bg-red-600">
          <div className="absolute inset-0 opacity-10"
            style={{backgroundImage:"linear-gradient(white 1px,transparent 1px),linear-gradient(90deg,white 1px,transparent 1px)",backgroundSize:"40px 40px"}}/>
          <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-14 flex flex-col sm:flex-row items-center justify-between gap-6">
            <div>
              <h3 style={{fontFamily:"'Syne',sans-serif",fontWeight:800}} className="text-2xl md:text-3xl text-white mb-1">
                Need a part right now?
              </h3>
              <p className="text-white/75 text-sm">We dispatch within 24 hours, nationwide.</p>
            </div>
            <button onClick={() => nav("#contact")}
              className="bg-white text-red-600 hover:bg-red-50 font-bold px-8 py-3.5 rounded-2xl text-sm transition-all duration-200 flex-shrink-0 shadow-xl">
              Get an Instant Quote →
            </button>
          </div>
        </div>

        {/* Main footer */}
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
            {/* Brand */}
            <div className="lg:col-span-2">
              <div className="flex items-center gap-2.5 mb-5">
                <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center">
                  <svg viewBox="0 0 36 36" fill="none" className="w-5 h-5">
                    <path d="M10 22 L14 12 L18 19 L22 12 L26 22" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                    <circle cx="18" cy="22" r="2.5" fill="white"/>
                  </svg>
                </div>
                <span style={{fontFamily:"'Syne',sans-serif",fontWeight:800}} className="text-white text-lg">
                  SuperFast <span className="text-red-500">Auto</span> Spares
                </span>
              </div>
              <p className="text-gray-400 text-sm leading-relaxed max-w-xs mb-1">
                Quality auto parts at unbeatable prices. Genuine components, lightning-fast delivery,
                and expert support — all in one place.
              </p>
              <p className="text-gray-600 text-xs mb-6">
                BW Elite LLC · Brandon Wetzel, Sole Mbr<br/>
                1009 W 540 N Apt A<br/>
                St. George, UT 84770<br/>
                United States
              </p>
              {/* Consent notice */}
              <div className="bg-gray-800 border border-gray-700 rounded-2xl p-4">
                <p className="text-gray-400 text-xs leading-relaxed">
                  <span className="text-red-400 font-semibold">Consent Notice: </span>
                    By providing your phone number and Submitting the form, you agree to receive transactional messages from Superfast Auto Parts. Msg freq varies.Msg & data rates may apply. Reply HELP for help and STOP to opt out. View our Terms & Privacy.
                </p>
              </div>
            </div>

            {/* Quick links */}
            <div>
              <h4 style={{fontFamily:"'Syne',sans-serif",fontWeight:700}}
                className="text-white text-sm uppercase tracking-wider mb-5">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map(l => (
                  <li key={l.href}>
                    <button onClick={() => nav(l.href)}
                      className="text-gray-400 hover:text-red-400 text-sm transition-colors">
                      {l.label}
                    </button>
                  </li>
                ))}
                <li><button onClick={() => setModal("terms")} className="text-gray-400 hover:text-red-400 text-sm transition-colors">Terms & Conditions</button></li>
                <li><button onClick={() => setModal("privacy")} className="text-gray-400 hover:text-red-400 text-sm transition-colors">Privacy Policy</button></li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 style={{fontFamily:"'Syne',sans-serif",fontWeight:700}}
                className="text-white text-sm uppercase tracking-wider mb-5">Contact</h4>
              <ul className="space-y-3 text-sm text-gray-400">
                <li>📞 +1 435-288-3089</li>
                <li>📧 info@superfastautospares.com</li>
                <li>📍 1009 W 540 N Apt A<br/>St. George, UT 84770<br/>United States</li>
                <li>⏰ Mon–Sat: 9 AM – 7 PM</li>
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="border-t border-gray-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-gray-600 text-sm">
              © 2024 BW Elite LLC. All rights reserved.
            </p>
            <div className="flex gap-5 text-xs">
              <button onClick={() => setModal("terms")} className="text-gray-600 hover:text-red-400 transition-colors">Terms</button>
              <button onClick={() => setModal("privacy")} className="text-gray-600 hover:text-red-400 transition-colors">Privacy</button>
            </div>
          </div>
        </div>
      </footer>

      <Modal isOpen={modal === "terms"} onClose={() => setModal(null)} title="Terms & Conditions">
        <TermsContent />
      </Modal>
      <Modal isOpen={modal === "privacy"} onClose={() => setModal(null)} title="Privacy Policy">
        <PrivacyContent />
      </Modal>
    </>
  );
}
